import React, { lazy, useRef, useState } from "react";

/** Common Components */
import CardSection from "../../components/ui/card/CardSection";
import CenterModal from "../../components/ui/centerModal/CenterModal";
import "./WordDocuments.scss";
/** Lazily Loaded Components */
const WordDocumentsList = lazy(() =>
  import("./components/wordDocumentsList/WordDocumentsList")
);
const AddEditWordDocuments = lazy(() =>
  import("./components/addEditWordDocuments/AddEditWordDocuments")
);

const WordDocuments = () => {
  const molGridRef = useRef();

  const [isEdit, setIsEdit] = useState(false);
  const [editWordDocumentsData, seteditWordDocumentsData] = useState(null);
  const [isWordDocumentsModelOpen, setIsWordDocumentsModelOpen] =
    useState(false);
    const [ docName ,setDocName] = useState()

  const handleAddWordDocumentsClick = () => {
    setIsWordDocumentsModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsEdit(false);
    setIsWordDocumentsModelOpen(false);
    seteditWordDocumentsData(null);
  };

  const handleEditClick = (data) => {
    setIsEdit(true);
    seteditWordDocumentsData(data);
    setIsWordDocumentsModelOpen(true);
  };

  const handleSuccess = () => {
    handleCloseModel();
    if (molGridRef.current) {
      molGridRef.current?.refreshGrid();
    }
  };

  return (
    <>
      <div className="word-document-sec">
        <CardSection
          cardTitle={"Word Document"}
          rightButton={true}
          buttonClassName={"blue-btn"}
          titleButtonClick={handleAddWordDocumentsClick}
          buttonText={"ADD"}
          searchInput={false}
          isButtonVisible={true}
          isButtonLoading={""}
          isIcon={true}
          iconClass="uil:plus"
        >
          <div className="only-list-body-scroll">
            <WordDocumentsList ref={molGridRef} onEdit={handleEditClick} setDocName={setDocName} />
          </div>
        </CardSection>
      </div>
      <CenterModal
        modalTitle={isEdit ? `Update Word Documents : ${docName}` : `Add Word Documents`}
        modalSize={isEdit ? "w-70" : "w-60"} 
        isOpen={isWordDocumentsModelOpen}
        onClose={handleCloseModel}
        transition={"grow"}
      >
        <AddEditWordDocuments
          isEdit={isEdit}
          onSuccess={handleSuccess}
          isOpen={isWordDocumentsModelOpen}
          initData={editWordDocumentsData}
          onClose={handleCloseModel}
        />
      </CenterModal>
    </>
  );
};

export default WordDocuments;
